

export default {
  SET_CARTS(state, payload) {
    state.items = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/carts/mutations.js